import mock from '../../mocks/$mock.js'
export default {
  install: (Vue, options) => {
    if (process.env.VUE_APP_USE_MOCK === 'true') {
      const mockServer = mock()
      mockServer.enableLog()
    }
  },
}
